// extracted by mini-css-extract-plugin
module.exports = {"icon":"PublishStatusIcon_icon__2_X9d","transparent":"PublishStatusIcon_transparent__3azbW"};